import styled from 'styled-components';
import background from '../../assets/images/sec1Background.jpg';
import background2 from '../../assets/images/section2Background.png';
import background3 from '../../assets/images/section3Background.png';
import { H1 } from '../../styles/FontStyles';

export const Section1Wrapper = styled.section`
  width: 100%;
  background-image: url(${background});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 200px 0;
  display: flex;
  flex-direction: column;

  img {
    width: 50%;
    cursor: pointer;
  }

  @media (max-width: 800px) {
    background-position: 24% 50%;
    padding: 150px 0;
    align-items: center;

    img {
      width: 100%;
    }
    svg {
      width: 100px !important;
      height: 100px !important;
    }
  }
`;

export const Section2Wrapper = styled.section`
  width: 100%;
  background-image: url(${background2});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 100px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const GrayBoxWrapper = styled.div`
  padding: 20px;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.gray};
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  width: 100%;

  > :nth-child(1) {
    background: linear-gradient(
      206.86deg,
      #eafcff 0.02%,
      #429fe7 35.85%,
      #0e2853 86.93%
    );

    color: ${({ theme }) => theme.white};

    img {
      -webkit-filter: drop-shadow(-13px 3px 37px #ff5f2948);
      filter: drop-shadow(-13px 3px 37px #ff5f2948);
    }
  }

  > div {
    box-shadow: 0px 4.06px 28.63px 0px rgba(0, 0, 0, 0.25);
    background-color: ${({ theme }) => theme.white};
    border-radius: 32px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 32px;
    img {
      width: 100%;
      margin-bottom: 32px;
    }

    /* FF5F29 */
  }

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

export const GrayBoxWrapper2 = styled.div`
  padding: 20px;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.gray};
  color: ${({ theme }) => theme.white};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;

  > div:nth-child(1) {
    background: linear-gradient(
        346.37deg,
        #0f1347 -0.25%,
        #4388d6 43.4%,
        #252d33 106.2%
      ),
      linear-gradient(0deg, rgba(49, 84, 165, 0.27), rgba(49, 84, 165, 0.27));
  }

  > div:nth-child(2) {
    background: linear-gradient(
        346.37deg,
        #2e1f1b -0.25%,
        #c2ac63 43.4%,
        #2d2820 106.2%
      ),
      linear-gradient(0deg, rgba(197, 117, 56, 0.27), rgba(197, 117, 56, 0.27));
  }

  img {
    width: 100%;
  }

  > div {
    display: flex;
    gap: 28px;
    padding: 32px;
    box-shadow: 0px 4.06px 28.63px 0px rgba(0, 0, 0, 0.25);
    background: linear-gradient(
        346.37deg,
        #131111 -0.25%,
        #160d0d 58.3%,
        #ff7051 106.2%
      ),
      linear-gradient(0deg, rgba(0, 0, 0, 0.27), rgba(0, 0, 0, 0.27));

    border-radius: 32px;
  }

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;

    > div {
      flex-direction: column;
    }
  }
`;

export const TextWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.primary};
  border-radius: 200px;
  padding: 8px 24px;
`;

export const Section4Wrapper = styled.section`
  width: 100%;
  background-image: url(${background3});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 150px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1000px) {
    padding: 100px 0;
  }
`;

export const Section4TextWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(135, 135, 135, 0.2);
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 30px 30px;
  border-radius: 24px;
  background: rgba(171, 171, 171, 0.1);
  transition: all 0.3s ease;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, #d9bd85 0%, #9a7e59 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: inherit;
    z-index: 0;
  }

  &:hover::before {
    opacity: 1;
  }

  /* content mora biti iznad background-a */
  & > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 800px) {
    padding: 20px 20px;
  }
`;

export const Section4Wrapper2 = styled.section`
  width: 100%;
  backdrop-filter: blur(105.80000305175781px);
  border: 1px solid #d0d0d0;
  padding: 80px 0;
  background: linear-gradient(
    90deg,
    rgba(0, 6, 10, 0.83) 0%,
    rgba(5, 37, 56, 0.4731) 54.16%,
    rgba(163, 221, 255, 0.249) 100%
  );

  @media (max-width: 1000px) {
    padding: 130px 0;
  }
`;

export const Section3Wrapper = styled.section`
  width: 100%;
  background-image: url(${background3});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  /* min-height: 100vh; */
  padding: 120px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Section5Wrapper = styled.section`
  width: 100%;
  background-image: url(${background3});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 200px 0;

  @media (max-width: 1000px) {
    padding: 100px 0;
  }
`;

export const Section1Image1 = styled.img`
  width: 100%;
  margin-bottom: 120px;
`;

export const Section1Image2 = styled.img`
  width: 100%;
`;

export const Section4Title = styled(H1)`
  span {
    background: linear-gradient(
      222.2deg,
      #ffb084 18.48%,
      #f02b00 52.72%,
      #ffffff 88.12%
    );

    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const Section3Boxes = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

export const Section3BoxesWrapper = styled.div<{
  width?: string;
  widthSM?: string;
}>`
  width: ${({ width }) => width || '100%'};
  border: 32px;
  background: ${({ theme }) => theme.white}1a;
  backdrop-filter: blur(44.6px);
  border: 0.5px solid ${({ theme }) => theme.gray}40;
  box-shadow: 0px 4.06px 28.63px 0px rgba(0, 0, 0, 0.25);
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  border-radius: 32px;

  svg {
    width: 80px !important;
    height: 80px !important;
  }

  div > * {
    color: ${({ theme }) => theme.white};
  }

  @media (max-width: 800px) {
    width: ${({ widthSM }) => widthSM || '100%'};
    padding: 24px;

    svg {
      width: 40px !important;
      height: 40px !important;
    }
  }
`;

export const Main = styled.div`
  max-width: 1600px;
  padding: 0 100px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 1000px) {
    padding: 0 30px;
  }
`;

export const Section5Text = styled.h2`
  /* font-family: 'instrumens'; */
  font-weight: 400;
  font-size: 180px;
  letter-spacing: -0.04em;
  line-height: 181.67px;
  text-align: center;
  color: ${({ theme }) => theme.white};
  margin: 0;

  font-family: FONTSPRING DEMO - Balgin;

  @media (max-width: 1000px) {
    font-size: 80px;
    line-height: 76.7px;
  }
`;

export const Section7Wrapper = styled.section`
  width: 100%;
  background-image: url(${background3});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 100px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1000px) {
    padding: 50px 0;
  }
`;

export const Section9Wrapper = styled.section`
  width: 100%;
  background-color: ${({ theme }) => theme.darkGray};
  padding: 100px 0;
`;
